module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Trash-9bdecbe7f2398985160ef25fd41c521f.svg";